import {AppState} from '../reducer';
import {User} from '../../incase-domain/user';
import {TypedTranslation} from '../../i18n';

export const hasLoginErrorSelector = (state: AppState): boolean => state.authReducer.hasError;
export const setLoginErrorMessageSelector = (state: AppState): TypedTranslation | null => state.authReducer.loginErrorMessage;
export const loggedInUserSelector = (state: AppState): User | undefined => state.authReducer.loggedInUser;
export const validationErrorsSelector = (state: AppState): Record<string, string[]> | undefined => state.authReducer.validationErrors;
export const isUserUpdatingSelector = (state: AppState): boolean => state.authReducer.isUserUpdating;
export const isLoggedInSelector = (state: AppState): boolean => state.authReducer.isLoggedIn;
